import ScrollToErrors from 'app/modules/scrollto-errors';
import Authentication from 'launch/modules/authentication-modal';
import UserRegistration from 'launch/data/user-registration';
import UserAuthentication from 'launch/data/user-authentication';
import 'launch/lib/jquery.jqbrowser.uncompressed.js';
import 'launch/lib/jquery.mailcheck.min.js';

$(function() {
    if ($('#authentication-modal').length) {
        Authentication.attachTo(document);
        UserRegistration.attachTo(document);
        UserAuthentication.attachTo(document);
    }

    ScrollToErrors.attachTo(document);
});



// WEBPACK FOOTER //
// ./src/web/js/launch/layout.js